import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=ba8c4aa6"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba8c4aa6')) {
      api.createRecord('ba8c4aa6', component.options)
    } else {
      api.reload('ba8c4aa6', component.options)
    }
    module.hot.accept("./PageLoading.vue?vue&type=template&id=ba8c4aa6", function () {
      api.rerender('ba8c4aa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/loaders/PageLoading.vue"
export default component.exports